import React from "react";
import SEO from "../components/SEO";
import scope2Preview from "../assets/scope2-tool-preview.mp4";

function Tools() {
  return (
    <div className="min-h-screen md:pt-44 pt-20 px-4">
      <SEO
        title="Free Scope 2 Self-Assessment Tool | Sustally"
        description="Try Sustally's free Scope 2 self-assessment tool to estimate greenhouse gas emissions from purchased electricity and review sustainability performance."
        url="/tools"
      />

      <div className="flex flex-col justify-center items-center mx-auto gap-6 mb-16 md:mb-24">
        <h1 className="font-semibold md:text-3xl text-xl max-w-4xl text-center">
          Free Sustainability Tools
        </h1>
        <h2 className="font-bold md:text-5xl text-3xl max-w-4xl md:text-center text-sustally-violet font-Poppins">
          Scope 2 Self-Assessment
        </h2>
        <p className="md:text-2xl text-lg max-w-4xl md:text-center font-Inter">
          A web-based application that helps organizations measure, monitor, and
          manage their sustainability performance through calculators,
          assessments, and reporting tools. Start with Sustally's free Scope 2
          self-assessment to estimate emissions from purchased electricity.
        </p>
      </div>

      <div className="flex flex-col gap-10 mt-10 md:mt-16 pb-20">
        <div className="flex flex-col md:flex-row md:gap-20 gap-10 justify-center items-center mx-auto">
          <div className="flex-1 h-full">
            <video
              loop
              className="rounded-2xl md:w-full w-[95%] h-full"
              autoPlay
              muted
              playsInline
              onContextMenu={(e) => e.preventDefault()}
            >
              <source src={scope2Preview} type="video/mp4" />
              Video about the Scope 2 Self Assessment tool.
            </video>
          </div>

          <div className="flex flex-col flex-1 bg-secondary-light dark:bg-secondary-dark rounded-2xl h-full mx-auto justify-center items-center">
            <h3 className="font-Poppins font-semibold md:text-3xl text-xl px-4 pt-10 text-sustally-violet md:pl-10">
              Scope 2 Self-Assessment
            </h3>
            <ul className="md:text-xl text-md font-Inter list-disc pb-6 pt-4 pl-8 md:pl-14 pr-4">
              <li>
                Calculate Carbon Emissions — Measure and track greenhouse gas
                (GHG) emissions accurately
              </li>
              <li>
                ESG Assessment — Evaluate sustainability performance using
                simple assessment tools
              </li>
              <li>
                Reports &amp; Insights — Generate clear reports and dashboards
                for better decision-making
              </li>
            </ul>
            <div className="w-full px-4 md:pl-10 pb-10 flex flex-wrap gap-4">
              <a
                href="https://sustally.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Try Scope 2 Self Assessment now"
                className="inline-flex items-center justify-center bg-sustally-violet text-white font-Inter font-medium md:px-10 px-8 py-3 rounded-full hover:scale-105 duration-200"
              >
                Try Now
              </a>
              <a
                href="https://drive.google.com/file/d/17UQyEHD3pa4vnD5vv1b0KuqHn9jgd9vk/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Watch Scope 2 demo video"
                className="inline-flex items-center justify-center border-2 border-sustally-violet text-sustally-violet font-Inter font-medium md:px-10 px-8 py-3 rounded-full hover:scale-105 duration-200"
              >
                Watch Demo
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tools;
